// extracted by mini-css-extract-plugin
module.exports = {"headerWidget":"style_headerWidget__70EJk","icon":"style_icon__2gGhr","body":"style_body__2TH1U"};